
/* 
    DECLARAMOS VARIABLES DE ENTORNO TOMADA DEL ARCHIVO .ENV O HARDCODEADO POR ACÁ
        NODE_ENV=> npm test --> test
        NODE_ENV=> npm start --> development
        NODE_ENV=> npm run build --> production
*/

import { OBJECT_FREEZE_HELPER } from "../../HELPERS/objectFreeze.helper";


const ENV_VALUE = (value) => (typeof value === "string" ? value.trim() : "");

const _SCHEMA = {

    APP__IS_NODE_ENV: process.env.NODE_ENV === 'development',

    APP__MODE_THEME_DARK: 'dark',
    APP__MODE_THEME_LIGHT: 'light',


    // ------------------------------- 🔥 INTEGRATIONS
    INTEGRATIONS: {

        PAYMENTS: {
            STRIPE: { PUBLIC_KEY: ENV_VALUE(process.env.REACT_APP_STRIPE_PUBLIC_KEY) },
            PAYPAL: { CLIENT_ID: ENV_VALUE(process.env.REACT_APP_PAYPAL_CLIENT_ID) },
            PAYONEER: { PROGRAM_ID: ENV_VALUE(process.env.REACT_APP_PAYONEER_PROGRAM_ID) },
            MERCADO_PAGO: { PUBLIC_KEY: ENV_VALUE(process.env.REACT_APP_MERCADO_PAGO_PUBLIC_KEY) },
        },

        CONNECT: {
            GOOGLE: { CLIENT_ID: ENV_VALUE(process.env.REACT_APP_GOOGLE_CLIENT_ID) },
            TWITTER: { CLIENT_ID: ENV_VALUE(process.env.REACT_APP_TWITTER_CLIENT_ID) },
            DISCORD: { CLIENT_ID: ENV_VALUE(process.env.REACT_APP_DISCORD_CLIENT_ID) },
            FACEBOOK: { CLIENT_ID: ENV_VALUE(process.env.REACT_APP_FACEBOOK_CLIENT_ID) },
            LINKEDIN: { CLIENT_ID: ENV_VALUE(process.env.REACT_APP_LINKEDIN_CLIENT_ID) },
            INSTAGRAM: { CLIENT_ID: ENV_VALUE(process.env.REACT_APP_INSTAGRAM_CLIENT_ID) },
        },

        MAPS: {
            GOOGLE: { EMBED_KEY: ENV_VALUE(process.env.REACT_APP_GOOGLE_MAPS_EMBED_KEY) },
        },

        STORAGE: {

            AWS: {
                BUCKET: ENV_VALUE(process.env.REACT_APP_AWS_BUCKET),
                REGION: ENV_VALUE(process.env.REACT_APP_AWS_REGION),
                PUBLIC_URL: ENV_VALUE(process.env.REACT_APP_AWS_PUBLIC_URL),
            },

            CLOUDINARY: {
                CLOUD_NAME: ENV_VALUE(process.env.REACT_APP_CLOUDINARY_CLOUD_NAME),
                FOLDER: ENV_VALUE(process.env.REACT_APP_CLOUDINARY_FOLDER),
                UPLOAD_PRESET: ENV_VALUE(process.env.REACT_APP_CLOUDINARY_UPLOAD_PRESET),
            },

            DRIVE: {
                CLIENT_ID: ENV_VALUE(process.env.REACT_APP_DRIVE_CLIENT_ID),
                FOLDER_ID: ENV_VALUE(process.env.REACT_APP_DRIVE_FOLDER_ID),
            },

            FIREBASE: {
                STORAGE_BUCKET: ENV_VALUE(process.env.REACT_APP_FIREBASE_STORAGE_BUCKET),
                API_KEY: ENV_VALUE(process.env.REACT_APP_FIREBASE_API_KEY),
                PROJECT_ID: ENV_VALUE(process.env.REACT_APP_FIREBASE_PROJECT_ID),
            },

            SUPABASE: {
                URL: ENV_VALUE(process.env.REACT_APP_SUPABASE_URL),
                ANON_KEY: ENV_VALUE(process.env.REACT_APP_SUPABASE_ANON_KEY),
                BUCKET: ENV_VALUE(process.env.REACT_APP_SUPABASE_BUCKET),
            },

            CLOUDFLARE_R2: {
                ACCOUNT_ID: ENV_VALUE(process.env.REACT_APP_R2_ACCOUNT_ID),
                BUCKET: ENV_VALUE(process.env.REACT_APP_R2_BUCKET),
                PUBLIC_CUSTOM_DOMAIN: ENV_VALUE(process.env.REACT_APP_R2_PUBLIC_CUSTOM_DOMAIN),
            },

            DIGITALOCEAN: {
                BUCKET: ENV_VALUE(process.env.REACT_APP_DIGITALOCEAN_BUCKET),
                REGION: ENV_VALUE(process.env.REACT_APP_DIGITALOCEAN_REGION),
                PUBLIC_URL: ENV_VALUE(process.env.REACT_APP_DIGITALOCEAN_PUBLIC_URL),
            },

            AZURE: {
                CONTAINER_NAME: ENV_VALUE(process.env.REACT_APP_AZURE_CONTAINER_NAME),
                ACCOUNT_NAME: ENV_VALUE(process.env.REACT_APP_AZURE_ACCOUNT_NAME),
            },
        }

    },

};


export const APP_ENVIRONMENT = OBJECT_FREEZE_HELPER.DEEP_FREEZE(_SCHEMA);
